
















import { computed, defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import BasePage from "@/components/BasePage";
import PageTitle from "@/components/PageTitle";
import MoreMenuItemDefault from "@/views/PageMore/components/MoreMenuItem/Integration/MoreMenuItemDefault";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "PageNotificationSettings",
  components: { MoreMenuItemDefault, PageTitle, BasePage },
  setup() {
    const { authUserStrict } = useAuthUser();

    const links = computed<IMoreMenuItem[]>(() => {
      return [
        ...(config.webPushNotificationsPublicKey
          ? [
              {
                label: $t("Push notifications"),
                name: "pushNotifications",
                to: {
                  name: "pushNotificationsSettings",
                },
              },
            ]
          : []),
        ...(authUserStrict.value.email
          ? [
              {
                label: $t("E-mail notifications"),
                name: "emailNotifications",
                to: {
                  name: "emailNotificationsSettings",
                },
              },
            ]
          : []),
      ];
    });

    return { links };
  },
});
